export const POSTHOG_ERROR_TYPES = {
	INVARIANT_CHECK_FAILED: 'invariant_check_failed',
};
